export const CTACategoryList = [
  { name: "Retail Pharmacies", slugurl: "retail-pharmacies" },
  { name: "Doctors", slugurl: "doctors" },
  {
    name: "Home Healthcare Service Providers",
    slugurl: "home-healthcare-service-providers",
  },
];

export const AppDownloadLinks = [
  // { name: "User App", slugurl: "user-app" },
  { name: "Doctor App", slugurl: "doctor-app" },
  { name: "Home Healthcare App", slugurl: "home-healthcare-app" },
  { name: "Pharmacy App", slugurl: "pharmacy-app" },
];

export const slugUrl = (slugName) =>
  slugName
    ?.trim()
    ?.toLowerCase()
    .replace(/[^a-z0-9 -]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");

export const convertSlugToNormalString = (slug) => {
  if (!slug) {
    return "";
  }
  const stringWithoutHyphens = slug.replace(/-/g, " ");
  const capitalizedString =
    stringWithoutHyphens.charAt(0).toUpperCase() +
    stringWithoutHyphens.slice(1);
  return capitalizedString;
};

export function convertToTitleCase(str) {
  // Split the string into an array of words
  var words = str.split("-");

  // Capitalize the first letter of each word
  var capitalizedWords = words.map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  });

  // Join the words back into a single string
  var result = capitalizedWords.join(" ");

  return result;
}

export const adLandingFormsList = [
  { name: "Partnered Doctors", slugurl: "partnered-doctors-online" },
  {
    name: "Partnered Retail Pharmacies",
    slugurl: "partnered-retail-pharmacies",
  },
  { name: "Users General", slugurl: "users-general" },
  { name: "Users - Order Medicines", slugurl: "users-order-medicines" },
  {
    name: "Users - Online Doctor Consultations",
    slugurl: "users-online-doctor-consultations",
  },
];

export const states = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Mehalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajastan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttarakhand",
  "Uttar Pradesh",
  "West Bengal",
  "Andaman and Nicobar",
  "Chandigarh",
  "Dadra and Nagar Haveli",
  "Delhi(NCT)",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshwadeep",
  "Puducherry",
];

export const years = Array.from(
  { length: new Date().getFullYear() - 1960 + 1 },
  (_, i) => (new Date().getFullYear() - i).toString()
);

export const degree = ["MBBS", "MS", "MD", "BDS", "MDS", "BAMS", "Others"];

export const physioDegree = ["BPT", "MPT", "Others"];

export const medicalCouncil = [
  "Andhra Pradesh Medical Council",
  "Arunachal Pradesh Medical Council",
  "Assam Medical Council",
  "Bhopal Medical Council",
  "Bihar Medical Council",
  "Bombay Medical Council",
  "Chandigarh Medical Council",
  "Chattisgarh Medical Council",
  "Delhi Medical Council",
  "Goa Medical Council",
  "Gujarat Medical Council",
  "Haryana Medical Councils",
  "Himachal Pradesh Medical Council",
  "Hyderabad Medical Council",
  "Jammu & Kashmir Medical Council",
  "Jharkhand Medical Council",
  "Karnataka Medical Council",
  "Madhya Pradesh Medical Council",
  "Madras Medical Council",
  "Mahakoshal Medical Council",
  "Maharashtra Medical Council",
  "Manipur Medical Council",
  "Medical Council of India",
  "Medical Council of Tanganyika",
  "Mizoram Medical Council",
  "Mysore Medical Council",
  "Nagaland Medical Council",
  "Orissa Council of Medical Registration",
  "Pondicherry Medical Council",
  "Punjab Medical Council",
  "Rajasthan Medical Council",
  "Sikkim Medical Council",
  "Tamil Nadu Medical Council",
  "Telangana State Medical Council",
  "Travancore Cochin Medical Council, Trivandrum",
  "Tripura State Medical Council",
  "Uttar Pradesh Medical Council",
  "Uttarakhand Medical Council",
  "Vidharba Medical Council",
  "West Bengal Medical Council",
  "Others",
];

export const config = {
  zIndex: 0,
  readonly: false,
  iframe: true,
  useInputsPlaceholder: true,
  sizeLG: 900,
  sizeMD: 700,
  sizeSM: 474,
  activeButtonsInReadOnly: ["source", "fullsize", "print", "about"],
  toolbarButtonSize: "middle",
  theme: "default",
  enableDragAndDropFileToEditor: true,
  saveModeInCookie: false,
  spellcheck: true,
  // editorCssClass: true,
  triggerChangeEvent: true,
  height: 220,
  direction: "ltr",
  language: "en",
  debugLanguage: false,
  i18n: "en",
  tabIndex: -1,
  toolbar: true,
  enter: "P",
  useSplitMode: false,
  colorPickerDefaultTab: "background",
  disablePlugins: ["paste", "stat"],
  events: {},
  textIcons: false,
  uploader: {
    insertImageAsBase64URI: true,
    imageExtensions: ["jpg", "jpeg", "png", "gif"],
  },
  imageExtensions: ["jpg", "jpeg", "png", "gif"],
  placeholder: "Type here",
  showXPathInStatusbar: false,
  imageProcessor: {
    replaceDataURIToBlobIdInView: Boolean,
  },
  imageDefaultWidth: 300,
  // selectionCellStyle: 'border: 1px solid #1e88e5 !important;',
  selectionCellStyle: "width: 100% !important",
  useExtraClassesOptions: true,
  table: {
    width: 100,
    data: {
      classList: {
        "table table-bordered": "Bootstrap Bordered",
        "table table-striped": "Bootstrap Striped",
        "table table-dark": "Bootstrap Dark",
      },
    },
  },
};

export const medicalCouncilOptions = {
  Allopathy: [
    "Andhra Pradesh Medical Council",
    "Arunachal Pradesh Medical Council",
    "Assam Council of Medical Registration",
    "Bihar Medical Council",
    "CHD Medical Council",
    "Chhattisgarh Medical Council",
    "Delhi Medical Council",
    "Goa Medical Council",
    "Gujarat Medical Council",
    "Haryana Medical Council",
    "Himanchal Pradesh Medical Council",
    "Jammu and Kashmir Medical Council",
    "Jharkhand Medical Council",
    "Karnataka Medical Council",
    "Kerala State Medical Councils",
    "Madhya Pradesh Medical Council(Bhopal Medical Council / Mahakaushal Medical Council)",
    "Maharashtra Medical Council",
    "Manipur Medical Council",
    "State Medical Council, Meghalaya",
    "Mizoram Medical Council",
    "Nagaland Medical Council",
    "Orissa Council of Medical Registration",
    "Punjab Medical Council",
    "Rajasthan Medical Council",
    "Sikkim Medical Council",
    "Tamil Nadu Medical Council",
    "Telangana State Medical Council",
    "Tripura State Medical Council",
    "Uttarakhand Medical Council",
    "Uttar Pradesh Medical Council",
    "West Bengal Medical Council",
    "National Medical Commission(erstwhile Medical Council of India)",
  ],
  Dentistry: [
    "Andhra Pradesh State Dental Council",
    "Arunachal Pradesh State Dental Council",
    "Assam State Dental Council",
    "Bihar State Dental Council",
    "Dental Council of Chandigarh",
    "Chhattisgarh State Dental Council",
    "Delhi State Dental Council",
    "Goa State Dental Council",
    "Gujarat State Dental Council",
    "Haryana State Dental Council",
    "Himachal Pradesh State Dental Council",
    "Jammu and Kashmir State Dental Council",
    "Jharkhand State Dental",
    "Council Karnataka State Dental Council",
    "Kerala Dental Council",
    "Madhya Pradesh State Dental Council",
    "Maharashtra State Dental Council",
    "Manipur State Dentists Registration Tribunal",
    "Meghalaya State Dental council",
    "Mizoram State Dentist Registration Tribunal",
    "Nagaland State Dental Council",
    "Orissa State Dental Council",
    "State Dental Council, Puducherry",
    "Punjab State Dental Council",
    "Rajasthan State Dental Council",
    "Sikkim Dental Registration Tribunal",
    "Tamil Nadu State Dental Council",
    "Telangana State Dental Council",
    "Tripura State Dental Council",
    "Uttarakhand Dentists Registration Tribunals",
    "Uttar Pradesh State Dental Council",
    "West Bengal State Dental Council",
    "Dental Council of India",
  ],
  Ayurveda: [
    "Andhra Pradesh Board for Indian Medicine and Homoeopathy",
    "Council of Indian Medicine, Arunachal Pradesh",
    "Assam State Council of Indian Medicine",
    "Bihar State Council of Ayurvedic and Unani Medicine",
    "Chhattisgarh Board of Ayurvedic and Unani System of Medicine and Naturopathy",
    "Delhi Bhartiya Chikitsa Parishad",
    "Goa Council of Ayurvedic and other Allied Indian Systems of Medicine",
    "Gujarat Board of Ayurvedic & Unani Systems of Medicine",
    "Council of Indian Medicine, Haryana",
    "Board of Ayurvedic and Unani Systems of Medicine, Himachal Pradesh",
    "Board of Ayurvedic & Unani System of Medicine, Jammu and Kashmir",
    "Jharkhand State Ayush Medical Council",
    "The Karnataka Ayurvedic & Unani Practitioners Board",
    "Kerala State Medical Councils",
    "Madhya Pradesh Board of Ayurvedic and Unani Systems of Medicine and Naturopathy",
    "Maharashtra Council of Indian Medicine",
    "Orissa State Council of Ayurvedic Medicine",
    "Board of Ayurvedic & Unani Systems of Medicine, Punjab",
    "Board of Indian Medicine, Rajasthan",
    "Tamil Nadu Board of Indian Medicine, Madras",
    "Government of Telangana Board of Indian Medicine",
    "Bhartiya Chikitsa Parishad, Uttarakhand",
    "Bhartiya Chikitsa Parishad, Uttar Pradesh",
    "Paschim Banga Ayurved Parishad",
    "National Commission for Indian System of Medicine (erstwhile Central Council of Indian Medicine)",
  ],
  Homeopathy: [
    "Andhra Pradesh Board for Indian Medicine and Homoeopathy",
    "Arunachal Pradesh Homoeopathic Council",
    "Board of Homoeopathic System of Medicine, Assam",
    "State Board of Homoeopathic Medicine, Bihar",
    "Homoeopathic system of Medicine, Chandigarh",
    "State Council of Homoeopathy, Chhattisgarh",
    "Board of Homoeopathic System of Medicine, Delhi",
    "The Goa Indian System of Medicine and Homoeopathy Council",
    "Council of Homoeopathic System of Medicine, Gujarat",
    "Council of Homoeopathic System of Medicine, Haryana",
    "Homoeopathic Medical Council, Himachal Pradesh",
    "Jammu and Kashmir Board of Homoeopathic System of Medicine",
    "Jharkhand State AYUSH Parishad",
    "Karnataka Board of Homoeopathic System of Medicine",
    "Kerala State Medical Councils",
    "Madhya Pradesh State Council of Homoeopathy",
    "Maharashtra Council of Homoeopathy",
    "Board of Homoeopathic Medicine, Meghalaya",
    "Mizoram State Council of Homoeopathy",
    "Board of Homoeopathic System of Medicine, Nagaland",
    "Odisha State Board of Homoeopathic Medicine",
    "Council of Homoeopathic System of Medicine, Punjab",
    "Rajasthan Homoeopathic Medical Board",
    "Tamil Nadu Homoeopathy Medical Council",
    "Government of Telangana Board of Indian Medicine",
    "Council of Homoeopathic Medicine, Tripura",
    "Homoeopathic Medicine Board, Uttarakhand",
    "Homoeopathic Medicine Board, Uttar Pradesh",
    "Council of Homoeopathic Medicine, West Bengal",
    "Central Council of Homoeopathy",
    "National Commission for Homoeopathy",
  ],
};
export const Fees = [
  "Less than INR 99",
  "INR 100 to INR 299",
  "INR 300 to INR 499",
  "INR 500 to INR 799",
  "INR 800 to INR 999",
  "More than INR 1000",
];

export const doctorProfileStatus = [
  "Select",
  "Registration Completed",
  "Onboarded",
  "Profile Activated",
  "Profile Suspended",
  "Profile Terminated",
];
export const webBookingProfileStatus = [
  "Not Interested",
  // "Delete",
  "Booking Confirmed",
  "Yet to Contact",
];

export const webBookingStatus = [
  "Yet to Contact Doctor",
  "Yet to Contact Only Patient",
  "Contacted Both Doctor & Patient Successfully",
];
export const BookingActions = [
  "Patient not Interested",
  "Patient Interested But Doctor not Available",
  "Booking Created Successfully for Patient",
];
export const AgentName = ["Yet to Assign", "Saradha", "Krupa"];

export const getWebBookingStatus = (el) => {
  if (el?.not_intrested) return "Not Interested";
  if (el?.booking_confirmed) return "Booking Confirmed";
  if (el?.yet_to_contact) return "Yet to Contact";
  return "Yet to Contact";
};
export const fetchWebBookingStatus = (el) => {
  return el?.booking_status || "Yet to Contact Doctor";
};
export const getWebBookingActionStatus = (el) => {
  return el?.booking_action;
};
export const getAgentStatus = (el) => {
  return el?.agent_assigned || "Yet to Assign";
};

export const careersFilterOptions = [
  "Gender",
  "Location",
  "Designation",
  "Across Healthsy",
];

export const acrossHealthsy = [
  "Referral",
  "Job Ads",
  "Organic Search",
  "Others",
];

export const fee = [
  "Less than INR 99",
  "INR 100 to INR 299",
  "INR 300 to INR 499",
  "INR 500 to INR 799",
  "INR 800 to INR 999",
  "More than INR 1000",
];

export const experience = [
  "Less than 1 Years",
  "1 - 2 Years",
  "2 - 3 Years",
  "3 - 5 Years",
  "5+ Years",
];

export const gender = ["Male", "Female", "Others"];

export const language = [
  "Tamil",
  "Telugu",
  "Hindi",
  "English",
  "Malayalam",
  "Kannada",
  "Bengali",
  "Marathi",
  "Punjabi",
  "Others",
];

export const service = [
  "Physiotherapist",
  "Nurse",
  "Mental Wellness Therapist",
  "Caretakers / Caregivers",
  "Speech Therapist",
  "Elderly Care Support",
  "Mother and Baby Care",
];

export const filterOptions = [
  "Gender",
  "Experience",
  "Location",
  "Language",
  "Service Category",
  "Lead Status",
  "BD",
];

export const Inventory = [
  "Less than 3 Lakhs",
  "5 - 20 Lakhs",
  "20 - 50 Lakhs",
  "50 Lakhs - 1 Crore",
  "More than 1 Crore",
];

export const sizeofPharmacy = [
  "120 to 150 Square feet",
  "150 to 200 Square feet",
  "200 to 300 Square feet",
  "300 to 500 Square feet",
  "More than 500 Square feet",
];

export const businessType = [
  "Sole - Proprietorship",
  "Private Limited",
  "HUF",
  "Partnership",
  "Public Limited",
  "OPC",
  "Others",
];

export const pharmacyFilterOptions = [
  "Inventory",
  "City / Town / Location",
  "Sizeof Pharmacy",
  "Business Type",
  "Lead Status",
  "BD",
];

export const instaDocFilterOptions = ["Lead Status", "BD"];

export const type = [
  {
    text: "Bank",
  },
  {
    text: "NBFC",
  },
  {
    text: "Brand",
  },
  {
    text: "Seller",
  },
  {
    text: "Influencer",
  },
  {
    text: "Company",
  },
  {
    text: "Individual",
  },
];

export const typeNew = [
  "Bank",
  "NBFC",
  "Brand",
  "Seller",
  "Influencer",
  "Company",
  "Individual",
];

export const specialisation = [
  {
    text: "Andrology",
  },
  {
    text: "Ayurveda",
  },
  {
    text: "Allergist",
  },
  {
    text: "Bariatrics",
  },
  {
    text: "Cardiology",
  },
  {
    text: "Cosmetology",
  },
  {
    text: "Dentistry",
  },
];
export const specialisationNew = [
  "Andrology",
  "Ayurveda",
  "Allergist",
  "Bariatrics",
  "Cardiology",
  "Cosmetology",
  "Dentistry",
  "Gynaecology / Obstetrics ",
];

export const preferredDay = ["Today", "Tomorrow", "Day After"];

export const status = ["Active", "Inactive"];

export const partneredDoctorsGender = ["Male", "Female"];

export const mode = ["Online", "Both"];

export const establishTypes = ["Hospital", "Clinic"];

export const inclinicMode = ["InClinic", "Both"];

export const filterOnlineDoctorsOptions = [
  "Primary Specialist",
  "Status",
  "Gender",
  "Mode",
  "Fee",
  "Language",
];

export const filterInclinicDoctorsOptions = [
  "Primary Specialist",
  "Status",
  "Gender",
  "City",
  "Mode",
  "Fee",
  "Language",
];

export const filterClinicProfileOptions = [
  "Clinic Specialty",
  "Clinic City",
  "Establish Type",
];

export const average = [
  "Less than 5 Lakhs",
  "5 - 10 Lakhs",
  "10 Lakhs to 15 Lakhs",
  "15 Lakhs - 20 Lakhs ",
  "20 Lakhs - 30 Lakhs ",
  "30 Lakhs - 50 Lakhs",
  "Above 50 Lakhs",
];

export const yesOrNo = ["Yes", "No"];

export const filterBlogsOptions = [
  "Menu",
  "Category",
  "Status",
  "Date of Publishing",
  "Trending",
  "Spotlight",
];

export const dateOfPublishing = [
  "This Week",
  "This Month",
  "Last 3 Months",
  "Last 6 Months",
];

export const trendingBlogs = ["#1 Trending", "#2 Trending"];

export const spotlight = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const typeList = ["Type"];

export const filterDoctorDemoOptions = ["Specialisation", "Preferred Day"];

export const statusValue = [
  { label: "Active", value: true },
  { label: "Inactive", value: false },
];

export const alphabets = Array.from({ length: 26 }, (_, i) =>
  String.fromCharCode(65 + i)
);

export const stock = ["Available", "Not Available"];

export const prescriptionType = ["Rx", "Non-Rx"];

export const returnable = ["Returnable", "Non Returnable"];

export const action = ["Active", "In-Active"];

export const MedicineStatus = [
  "Available",
  "Out Of Stock",
  "Discontinued",
  "Not For Sale",
  "Banned For Sale",
];
